module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2c",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "imageb1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "15",
      "src": "images/common.jpg",
      "width": "97"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("hey laid Arthur on a green canvas tarp, so close to the crowd that a few people tried to back away but couldn’t because the people at the rear were still pushing forward to see. Nobody could move so we just had to stand there in the cold night and stare down at Arthur and his head that was at a funny angle and his wet hair that was starting to freeze to his forehead and his hands that were gray-blue with darker gray fingernails. We all stood there with our hands in our pockets and nobody said anything except an old guy from mill security who was in uniform but looked like he’d spent a few hours drinking at the Legion.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Eh, Christ,” he said, pronouncing it the French way, "), _c('i', [_vm._v("Crist")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("We all stood there and wished something would happen but there was some screw-up with the hearse being blocked by a fireman’s pickup so we had to wait, like people gathered around somebody who had collapsed in the street. There was nothing you could say so we stared dumbly at Arthur—at his glasses that were still on his face but perched crooked, at the bare patch of hairy white ankle that showed because his socks had fallen down.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("He really didn’t look bad, considering.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("“Come on, move it back,” somebody said behind me, and I turned to see firemen in boots and raincoats with "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANDROSCOGGIN FD")]), _vm._v(" stenciled on the backs. They were pushing a stretcher through the crowd and behind them was Steve Theriault from the funeral home, bald and chubby and carrying a light green sheet. The four of them pushed through and raised the stretcher to waist height, then stood eyeing Arthur and huffing steamy breath into the night air. Two of the firemen hunched over and picked Arthur up by the legs and the other two, including Theriault, got him by the armpits. One of them grunted.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("I guess that’s why they call it dead weight.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("After they got him up and on, they straightened Arthur on the stretcher and put the sheet over his face, just like on television. His feet still stuck out, also just like on television, but they didn’t cover them. They just plowed back into the crowd, which parted and then followed as if the whole thing were some strange public funeral procession, held under the glare of the lights.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("I brought up the rear, scanning the crowd as it dissolved among the cars and pickups like fans leaving a football game.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Come on,” I said. “Where’s a cop when you need one?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_vm._v("The cop turned out to be Lieutenant Vigue who, by the time I got to him, was all worked up—not by the tragedy of Arthur’s death, but by the traffic snarl it was causing where the mill road met the highway.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Vigue was standing in the road, waving a flashlight and motioning like one of those people who direct jets on the deck of an aircraft carrier. Half the town had stopped to see Arthur pulled from the "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("water, and now their cars and trucks were streaming back onto the highway while Vigue held back the log trucks that waited in a long dieseling line, their air brakes hissing impatiently, drivers commiserating into the mikes of their CBs.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Hey, Lieutenant,” I said. “What’s happening?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“You know what we know,” Vigue said.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“What’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Vigue looked at me sideways, tense and irritable in the flashing glare of the strobe lights.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Not much. It’s Arthur. He was in the river. He’s dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Who found him?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("He looked at me sideways again.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“You in a hurry or what?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("I shrugged. He pulled the clip mike off his jacket collar and held it up.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Nine-one, nine-three.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("His radio chirped something unintelligible.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“You got the names, times on this one?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Another chirp.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Bring it down here, will ya? "), _c('i', [_vm._v("New York Times")]), _vm._v(" is here.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Chirp again.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The last of the viewing audience pulled out of the mill road and high above us the trucks began to move through. They roared and rumbled and spouted plumes of exhaust smoke, like huge mechanical dragons. We stood by Vigue’s idling cruiser and waited. He lit a cigarette, his face taut and handsome in the flicker of the lighter’s flame.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“So what do you think happened?” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Who the hell knows?” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Where’s the autopsy?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("“Augusta.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“State guys in on it?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Only on paper. Unless it turns out to be something.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Like what?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Not suicide. Not accidental. Five bullet holes in the back. Something like that. But don’t get your hopes up.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Even without that it’s strange,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Vigue waved a balky truck through.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“That so?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Don’t you think so? I mean, how’d he get here? Out here in the middle of nowhere. Mill people don’t even come down here. He didn’t drive. You see him walking all the way down here? In the cold? What’s he gonna do? Go for a swim?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Wouldn’t be a long swim,” Vigue said. “Friggin’ ice water sucks the life right out of you, Mister Man. Only good thing is they don’t smell when you pull ’em out of the water.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Nothing like a silver lining,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Yup.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("We stood for a minute as the cars wound their way up to the main road above us. A police cruiser came down the access road, driven hard and fast the way cops like to drive. It pulled up and stopped and a patrolman got out, leaving the motor running. Cops like to do that, too.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("His name tag said "), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEMAIRE, J")]), _vm._v("., and Vigue looked at him and then nodded toward me, just barely.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“How’s the mild-mannered reporter tonight?” LeMaire, J. asked.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Just wonderful.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“What can we do you for?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("I asked for names. LeMaire, J. told me a trucker from Quebec, a chip hauler, called it in. There was some confusion because the trucker, one Yves Martin, forty-six, of St. Agathe, called it in "), _c('i', [_vm._v("en français")]), _vm._v(". He’d been flagged down by two kids, boys in their teens, who were wandering through the mill yards, probably looking for something to break or steal, when one saw something in the water where the river cuts through the mill canal.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“That was Arthur?” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“You saw him, didn’t you?” Vigue said.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("I had my notebook out.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“For the record. Official, you know? You ID’d him as Arthur Bertin.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Two-thirty-five Carolina, Androscoggin,” LeMaire, J. said, reading off a tiny yellow coil-bound pad. “DOB six twenty-six forty-six.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("I scribbled. My hands were stiff from the cold.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Any sign of foul play?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Not at the present time,” Vigue said, his voice slipping lower, more serious. “No sign of anything except a dead body. You have to wait for the results of the autopsy. So it’s under investigation. Pretty much. I can tell you we won’t have much to move on until the cause of death is determined.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“But what do you think now?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“What do I think?” Vigue said.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Yeah,” I said, stuffing my pen hand in my pocket. It was an old trick: The pen goes in the pocket; the source tends to relax.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“What do you think?” I continued. “On the face of it, you know? Preliminary or whatever.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Hey, preliminary, it looks like a guy drowned. He’s in the water and he’s dead. But preliminary is preliminary. It isn’t the final ruling.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("“You mean accidental drowning? Accidental?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Under investigation. That’s what I mean. When the autopsy comes in we’ll know more.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“But Lieutenant, you know how you were saying the cold, how it sucks the life right out of you—”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“That was off the record.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Okay. Off the record. Between us. If somebody got thrown or pushed in the water, or whatever. You know you wouldn’t be able to find a way up that concrete wall. You saw the wall. What I’m saying is, the guy would drown but it wouldn’t be an accident. Right?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Vigue lit another cigarette with the lighter from his breast pocket. The lighter was green plastic. It glowed under his face and then went out and then he looked at me.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Friggin’ A,” he said. “I thought this guy was supposed to be a friend of yours. What’s the matter? Drowning ain’t good enough for you? Ain’t front-page? Gotta be a homicide?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Doesn’t have to be anything. Just has to be true.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Well, here’s what’s true: Arthur Bertin is in the water. He’s dead. We don’t know what happened, but we’ll find out. Maybe.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("I wrote in my notebook.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“And they say cops are cold bastards,” Vigue said.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“We’re all cold bastards tonight,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("In the glow of the cigarette, I saw him smile.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8418ec00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter01.vue
// module id = 75
// module chunks = 0